export const LikelihoodDirection_dV = 'd|V';
export const LikelihoodDirection_vD = 'v|D';
export const LikelihoodDirections = [LikelihoodDirection_dV, LikelihoodDirection_vD];
//# sourceMappingURL=types.js.map